module.exports = __webpack_public_path__ + "img/4.e4f38bc8.png";